<template>
    <div>
        <UiHeroTop :article="blogStore.filterArticlesByTag(blog, 'Herobanner')[0]" />
        <p></p>
        <UiImageFlip 
            v-for="(article, index) in blogStore.filterArticlesByTag(blog, 'Feature')" 
            :key="index" 
            :article="article"
            class="bg-warmgray-super-light  pt-6"
        />
    </div>

    <div class="mt-32">
        <p></p>
        <UiImageFlip 
            v-for="(article, index) in blogStore.filterArticlesByTag(blog, 'Additional Info')" 
            :key="index" 
            :article="article"
            class="mt-16 mb-16"
        />
    </div>    

</template>
  
<script setup>
import { useBlogStore } from '@/stores/blogStore';
const blogStore = useBlogStore();

// Definiera props
const props = defineProps({
  blog: {
    type: Object,
    required: true
  }
});


</script>
  
  <style scoped>
/* Adjust spacing for smaller screens */
@media (max-width: 768px) {


.mt-24 {
  margin-top: 36px;
}

.mt-16, .mb-16 {
  margin-top: 36px;
  margin-bottom: 36px;
}
}  

@media (max-width: 480px) { /* Extra small screens */
.mt-32 {
  margin-top: 64px;
}

  .mt-24 {
  margin-top: 24px;
}

.mt-16, .mb-16 {
  margin-top: 24px;
  margin-bottom: 24px;
}

.mx-8 {
  margin-left: 16px;
  margin-right: 16px;
}
}

</style>
  